<article>
  <h5>{{ post.title }}</h5>
  <h6>{{ post.pubDate }}</h6>
  <p>{{post.description}}</p>
  <a [attr.href]="post.link" [attr.target]="target">Read full article</a>
</article>
